// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientBlock_root__3HKt8","header":"PatientBlock_header__yXDkZ","label":"PatientBlock_label__2A4zP","option":"PatientBlock_option__2ARBa"};